import { get, startCase, uniqueId } from "lodash";
import {
  ILayoutSettings,
  PageSectionCategory,
} from "@/Apps/Pages/Sections/WebLayouts/types";
import { ComponentTypes } from "@/Apps/Pages/Editor/types";
import { BenefitLayouts } from "../types";

import { combineData, lorem } from "../../utils";
import { style } from "./style";
import { IconTypes } from "@/Apps/Pages/WebComponents/v2/Icon";
import { default as defaultData } from "./data.json";
import {
  getImagePlaceholder,
  ImagePlaceholderTypes,
  getVideoPlaceholder,
  VideoPlaceholderTypes,
} from "../../Placeholders";
import theme from "../../theme";
const content = combineData(defaultData);

const settings: ILayoutSettings = {
  label: BenefitLayouts.SEVEN,
  layout: BenefitLayouts.SEVEN,
  previewImage:
    "https://sandcastleassets.s3.amazonaws.com/blocks/benefits/Benefit07.png",
  loadFromExt: true,
  loadFromExtSettings: {
    pageId: "ckkx36rg821t10780ogx3g72b",
    itemId: "8gsyyl9ojqf",
  },
  default: {
    label: PageSectionCategory.BENEFIT,
    type: ComponentTypes.SECTION,
    bodyOnly: true,
    canHaveChildren: true,
    properties: {
      ...style.SECTION,
      ...style.SECTION_INNER,
    },
    children: [
      {
        type: ComponentTypes.COLUMNS,
        canHaveChildren: false,
        properties: {
          width: "100%",
        },
        children: [
          {
            type: ComponentTypes.COLUMN,
            canHaveChildren: true,
            preventDelete: true,
            md: parseInt((6 * 100) / 12),
            properties: { height: "100%", padding: 0, minHeight: 20 },
            children: [
              getImagePlaceholder({
                type: ImagePlaceholderTypes.NONE,
                style: {
                  height: "100%",
                  backgroundColor: theme.foregroundColor,
                },
              }),
            ],
          },
          {
            type: ComponentTypes.COLUMN,
            canHaveChildren: true,
            preventDelete: true,
            md: parseInt((6 * 100) / 12),
            properties: { height: "100%", padding: 0, minHeight: 20 },
            children: [
              {
                type: ComponentTypes.CONTAINER,
                canHaveChildren: true,
                properties: {
                  mobile: {
                    desktop: {
                      padding: 100,
                    },
                    smartphone: {
                      padding: 20,
                    },
                  },
                },
                children: [
                  {
                    type: ComponentTypes.HEADLINE,
                    canHaveChildren: false,
                    properties: {
                      ...style.HEADLINE,
                      ...get(content, "main_headline.style", {}),
                    },
                    html: get(content, "main_headline.html", "..."),
                  },
                  {
                    type: ComponentTypes.CONTAINER,
                    canHaveChildren: true,
                    properties: {
                      ...style.LIST,
                    },
                    children: [
                      {
                        type: ComponentTypes.LISTITEM,
                        canHaveChildren: false,
                        properties: {
                          ...style.LI.style,
                        },
                        iconStyle: style.LI.iconStyle,
                        contentStyle: style.LI.contentStyle,
                        icon: IconTypes.CheckCircleOutline,
                        html: `<p style="font-size: 16pt"><strong>Highlighted Feature</strong></p><p></p><p style="font-size: 11pt; padding: 0">It's true.  Getting results is much easier than you think.  The truth is</p>`,
                      },
                      {
                        type: ComponentTypes.LISTITEM,
                        canHaveChildren: false,
                        properties: {
                          ...style.LI.style,
                        },
                        iconStyle: style.LI.iconStyle,
                        contentStyle: style.LI.contentStyle,
                        icon: IconTypes.CheckCircleOutline,
                        html: `<p style="font-size: 16pt"><strong>Highlighted Feature</strong></p><p></p><p style="font-size: 11pt; padding: 0">It's true.  Getting results is much easier than you think.  The truth is</p>`,
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
};

export default settings;
